;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .controller(
      'ModalTraceMarkStatusInstanceCtrl',
      ModalTraceMarkStatusInstanceCtrl
    )

  function ModalTraceMarkStatusInstanceCtrl(
    $scope,
    $routeParams,
    $uibModalInstance,
    logger,
    appTracesApiConfig,
    serverVulnsApiConfig,
    orgTraceApiConfig,
    ErrorService,
    traceCommonRenderService,
    GoogleAnalyticsService,
    traces,
    commentPreference,
    VULNERABILITY_SUBSTATUS
  ) {
    'ngInject'

    $scope.model = {}
    $scope.model.traces = traces
    $scope.model.executing = false
    $scope.select = {}
    $scope.select.substatus = VULNERABILITY_SUBSTATUS

    $scope.ok = function () {
      $scope.model.executing = true

      var data = {
        traces: traces,
        status: 'NotAProblem',
        substatus: $scope.model.substatus,
        note: $scope.note,
        comment_preference: commentPreference
      }

      var promise

      if ($routeParams.appId) {
        promise = appTracesApiConfig.markStatus($routeParams.appId, data)
      } else if ($routeParams.serverId) {
        promise = serverVulnsApiConfig.markStatus($routeParams.serverId, data)
      } else {
        promise = orgTraceApiConfig.markStatus(data)
      }

      return promise.then(
        function (response) {
          $scope.model.executing = false
          logger.logSuccess(response.data.messages[0])
          $uibModalInstance.close(data.substatus)

          var gaEvent = {
            category: 'Vulnerability',
            action: 'Mark As Not a Problem - ' + data.substatus
          }
          GoogleAnalyticsService.sendEvent(gaEvent)

          traceCommonRenderService.securityControlDialog(data.substatus, {
            language: '',
            api: '',
            traces: traces
          })
        },
        function (response) {
          $scope.model.executing = false
          ErrorService.processError(response)
        }
      )
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
